/**
 * Balance Module
 *
 */

angular
  .module('balance', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.balance.buy(), {
        controller: 'BalanceBuyCtrl',
        templateUrl: '/r/static/templates/balance/buy.html',
      })
      .when(CONFIG.url.balance.thanks(), {
        controller: 'BalanceThanksCtrl',
        templateUrl: '/r/static/templates/balance/thanks.html',
      })
    // .when(CONFIG.url.balance.earn(), {controller:'BalanceEarnCtrl', templateUrl:'/r/static/templates/balance/earn.html'})
  }])
  .factory('Balance', ['$resource', function ($resource) {
    var Balance = $resource(
      CONFIG.api('balance'),
      {},
      {
        buy: {method: 'POST', isArray: false, params: {id: 'buy'}},
        send_email: {method: 'POST', isArray: false, params: {id: 'send_email'}},
      },
    )
    return Balance
  }])

/* Controllers */

angular.module('balance').controller('BalanceBuyCtrl', ['$scope', '$rootScope', '$location', 'Balance', 'Settings', function ($scope, $rootScope, $location, Balance, Settings) {
  $scope.utils.setPageTitle(_('balance_get_title'))
  $scope.utils.setPageID('default')

  a4.loaded($scope)

  Settings.get({}, function (settings) {
    $scope.settings = settings
    $scope.selected_amount = 50
  })

  $scope.buy = function () {
    Balance.buy(
      {},
      {
        amount: parseInt($scope.selected_amount),
      },
      // success
      function (data) {
        $location.path(CONFIG.url.mooney.charge(data['mid'])).search('goto', CONFIG.get('urls.balance.thanks'))
      },
      // error
      a4.restErrorFactory($scope),
    )
  }

  // $scope.earn = function() {
  //   $location.path(CONFIG.url.balance.earn());
  // };

  $scope.$watch('selected_amount', function () {
    // loop this in a more fancy way
    if ($scope.selected_amount > 0) {
      $scope.item_counts = {
        invoice: {
          email: Math.floor($scope.selected_amount / $scope.settings.prices_.invoice.email),
          letter: Math.floor($scope.selected_amount / $scope.settings.prices_.invoice.letter),
          sms: Math.floor($scope.selected_amount / $scope.settings.prices_.invoice.sms),
        },
        announcement: {
          email: Math.floor($scope.selected_amount / $scope.settings.prices_.announcement.email) || 'Free',
          letter: Math.floor($scope.selected_amount / $scope.settings.prices_.announcement.letter),
          sms: Math.floor($scope.selected_amount / $scope.settings.prices_.announcement.sms),
        },
        updreq: {
          email: Math.floor($scope.selected_amount / $scope.settings.prices_.updreq.email),
          letter: Math.floor($scope.selected_amount / $scope.settings.prices_.updreq.letter),
          sms: Math.floor($scope.selected_amount / $scope.settings.prices_.updreq.sms),
        },
        membercard: {
          sms: Math.floor($scope.selected_amount / $scope.settings.prices_.membercard.sms),
        },
      }
    }
  })
}])

angular.module('balance').controller('BalanceThanksCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
  $scope.utils.setPageID('default')
  a4.loaded($scope)
}])

// Disabled for now, fb:111368.

// angular.module('balance').controller('BalanceEarnCtrl', function ($scope, $rootScope, $timeout, Balance, Settings) {

//   $scope.utils.setPageID('default');

//   Settings.get({}, function(settings) {
//     $scope.settings = settings;
//     $scope.referral_url = _('balance_earn_referral_url', {site_num: $scope.settings.num_, person_id: $rootScope.session.user.id});
//     // So that Facebook will wait us a bit
//     a4.timeout($timeout, $scope, function() { FB.XFBML.parse(); }, 1);
//     a4.loaded($scope);
//   });

//   // Facebook share button
//   (function(d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s); js.id = id;
//     js.src = "//connect.facebook.net/fi_FI/all.js#xfbml=1&status=0";
//     fjs.parentNode.insertBefore(js, fjs);
//   }(document, 'script', 'facebook-jssdk'));

//   $scope.send_emails = function() {

//     var emails;

//     $scope.emails_warning = false;
//     $scope.emails_sent = false;

//     if($scope.email_addresses) {
//       var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//       emails = $scope.email_addresses.replace(/[^,;]*.?</g,"").replace(/>/g,"").replace(/[,; ]{1,}/g, "\n").replace(/[\n]{2,}/g, "\n").split("\n");
//       $.each(emails, function(idx, val) {
//         if(!re.test(val)) {
//           $scope.emails_warning = true;
//           return;
//         }
//       });
//     } else {
//       $scope.emails_warning = true;
//     }

//     if($scope.emails_warning) {
//       return;
//     }

//     Balance.send_email(
//       {},
//       {
//         product: $scope.settings.product_,
//         invite_link: $scope.referral_url,
//         recommender_name: $rootScope.D4GLOBALS.User.Fullname,
//         emails: emails
//       },
//       // success
//       function(data) {
//         $scope.emails_sent = true;
//       },
//       // error
//       a4.restErrorFactory($scope)
//     );

//   };

//   $scope.copy_to_clipboard = function() {
//     window.prompt(_('balance_copy_to_clipboard'), $scope.referral_url);
//   };

// });
